import axios from 'axios';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    setSeries(state, payload) {
      state.list = payload;
    },
  },
  actions: {
    async fetch({ commit, rootState }) {
      const response = await axios.get(`${rootState.api.baseUrl}/series`);
      commit('setSeries', response.data.response);
    },
  },
};
